import * as SpriteSpin from "spritespin";
jQuery(function () {
    const elements = document.getElementsByClassName('wm-spritespin');
    for (let i = 0; i < elements.length; i++) {
        const target = elements[i];
        const url = target.dataset.url;
        const frames = parseInt(target.dataset.frames);
        if (!url) {
            return;
        }
        SpriteSpin.create({
            target: elements[i],
            source: SpriteSpin.source(`${url}{frame}.png`, {
                frame: [0, frames],
                digits: 4,
            }),
            frameTime: 200,
            animate: true,
            fillMode: 'contain',
            renderMode: 'background'
        });
    }
});
